module.exports = __webpack_public_path__ + "media/wo_chi_fan1.efb8fb56.mp3";